import GuestFormSFC from "./GuestForm.vue";
export const GuestForm = GuestFormSFC;
